// Import strategies
import activeDetailStrategy from './activeDetailStrategy';
import defaultDetailStrategy from './defaultDetailStrategy';
import fieldMarkedDetailStrategy from './fieldMarkedDetailStrategy';
import flagDetailStrategy from './flagDetailStrategy';
import linkDetailStrategy from './linkDetailStrategy';
import proposalRequestDetailStrategy from './proposalRequestDetailStrategy';
// Get all strategy modules
const getStrategyModules = () => {
    const modules = [
        activeDetailStrategy,
        fieldMarkedDetailStrategy,
        flagDetailStrategy,
        linkDetailStrategy,
        proposalRequestDetailStrategy
    ];
    return modules.map((module) => module());
};
export default function createStrategyRegistry() {
    const strategies = getStrategyModules();
    const defaultStrategy = defaultDetailStrategy();
    return {
        getStrategy: (key) => strategies.find((s) => s.appliesTo(key)) || defaultStrategy
    };
}
